import { render, staticRenderFns } from "./InputTicketType.vue?vue&type=template&id=1b7bb344&scoped=true"
import script from "./InputTicketType.vue?vue&type=script&lang=js"
export * from "./InputTicketType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7bb344",
  null
  
)

export default component.exports